// @flow

import { ActionsObservable } from 'redux-observable';
import 'rxjs/add/operator/map';
import { activate } from 'modules/rootEpic';
import { searched as searchEvents } from 'modules/search/rest';
import { buildSearchEventQueryExpression, EVENT_LIMIT } from 'services/query/query';

import { fetchWhiteLabelDone } from 'modules/whiteLabel/duck';

import {
  ON_UMBRELLA_MOUNT,
  CHANGE_PAGE,
  fetchUmbrellaEvent,
  FETCH_UMBRELLA_EVENT,
  fetchUmbrellaEventDone,
  FETCH_UMBRELLA_EVENT_DONE,
} from './duck';

export const onUmbrellaMountEpic = (actions$: ActionsObservable) => actions$.ofType(ON_UMBRELLA_MOUNT)
  .mergeMap((action) => {
    const offset = 1;
    const limit = 20;
    const { portalId } = action.payload;
    const { portalType } = action.payload;
    const q = buildSearchEventQueryExpression('');

    return searchEvents({
      q,
      offset,
      limit,
      portalType,
      portalId,
    }, (response) => {
      const events = response.items;
      const total = response.meta.totalCount;

      return fetchUmbrellaEventDone({
        events,
        total,
      });
    });
  });

export const fetchUmbrellaEventEpic = (actions$: ActionsObservable) => actions$.ofType(FETCH_UMBRELLA_EVENT)
  .mergeMap((action) => {
    const {
      keywords, offset, limit, portalType, portalId,
    } = action.payload;
    const q = buildSearchEventQueryExpression(keywords);
    return searchEvents({
      q,
      offset,
      limit,
      portalType,
      portalId,
    }, (response) => {
      const events = response.items;
      const total = response.meta.totalCount;

      return fetchUmbrellaEventDone({
        events,
        total,
      });
    });
  });

export const fetchUmbrellaEventDoneEpic = (actions$: ActionsObservable) => actions$.ofType(FETCH_UMBRELLA_EVENT_DONE)
  .map(fetchWhiteLabelDone);

export const changePageEpic = (actions$: ActionsObservable) => actions$.ofType(CHANGE_PAGE)
  .map((action) => {
    const {
      latestKeywords, index, portalType, portalId,
    } = action.payload;

    return fetchUmbrellaEvent(latestKeywords, (index - 1) * EVENT_LIMIT + 1, EVENT_LIMIT, portalType, portalId);
  });

activate(onUmbrellaMountEpic);
activate(fetchUmbrellaEventEpic);
activate(fetchUmbrellaEventDoneEpic);
activate(changePageEpic);
